export const TIMEZONES = [
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Denver',
  'America/Los_Angeles',
  'America/Anchorage',
  'Pacific/Honolulu',
  'America/Toronto',
  'America/Vancouver',
  'America/Sao_Paulo',
  'America/Argentina/Buenos_Aires',
  'America/Mexico_City',
  'Europe/London',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Madrid',
  'Europe/Rome',
  'Europe/Amsterdam',
  'Europe/Brussels',
  'Europe/Zurich',
  'Europe/Stockholm',
  'Europe/Oslo',
  'Europe/Helsinki',
  'Europe/Warsaw',
  'Europe/Athens',
  'Europe/Bucharest',
  'Europe/Moscow',
  'Europe/Istanbul',
  'Asia/Dubai',
  'Asia/Kolkata',
  'Asia/Bangkok',
  'Asia/Singapore',
  'Asia/Shanghai',
  'Asia/Hong_Kong',
  'Asia/Taipei',
  'Asia/Seoul',
  'Asia/Tokyo',
  'Australia/Sydney',
  'Australia/Melbourne',
  'Australia/Perth',
  'Pacific/Auckland',
  'Africa/Cairo',
  'Africa/Lagos',
  'Africa/Johannesburg',
]

export function formatDatetimeInTimezone(utcDateString: string, timezone: string): string {
  if (!utcDateString) return ''
  try {
    const date = new Date(utcDateString.replace(' ', 'T') + 'Z')
    if (isNaN(date.getTime())) return utcDateString
    return date.toLocaleString('en-US', {
      timeZone: timezone || 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    })
  } catch {
    return utcDateString
  }
}

export function getTimezoneLabel(tz: string): string {
  try {
    const now = new Date()
    const offset = now.toLocaleString('en-US', { timeZone: tz, timeZoneName: 'shortOffset' })
    const match = offset.match(/GMT([+-]\d+:?\d*)/)
    const offsetStr = match ? ` (GMT${match[1]})` : ''
    return `${tz}${offsetStr}`
  } catch {
    return tz
  }
}
